#import "./ParashahDetails.graphql"
#import "./AliyahDetails.graphql"
#import "./HaftarahDetails.graphql"
#import "./LightBarMitzvahDetails.graphql"
#import "./PronunciationDetails.graphql"
#import "./TorahMelodyDetails.graphql"
#import "./HaftarahMelodyDetails.graphql"
#import "./SentenceGroupMelodyDetails.graphql"
#import "./SentenceGroupDetails.graphql"

fragment barMitzvahDetails on BarMitzvahType {
  ...lightBarMitzvahDetails
  pronunciation {
    ...pronunciationDetails
  }
  torahMelody {
    ...torahMelodyDetails
  }
  haftarahMelody {
    ...haftarahMelodyDetails
  }
  sentenceGroupMelody {
    ...sentenceGroupMelodyDetails
  }
  aliyot {
    ...aliyahDetails
    parashah {
      ...parashahDetails
    }
  }
  haftarah {
    ...haftarahDetails
  }
  sentenceGroups {
    ...sentenceGroupDetails
  }
}
